import { Icon, SpaceBetween } from '@cloudscape-design/components';

export type StarsIconProps = {
  stars?: number;
};

export function StarsIcon({ stars = 0 }: StarsIconProps) {
  // Round to the nearest half star (e.g., 4.3 → 4.5, 4.2 → 4.0)
  const roundedStars = Math.round(stars * 2) / 2;
  const icons = [];

  for (let i = 1; i <= 5; i++) {
    if (roundedStars >= i) {
      icons.push(<Icon key={i} name="star-filled" />);
    } else if (roundedStars >= i - 0.5) {
      icons.push(<Icon key={i} name="star-half" />);
    } else {
      icons.push(<Icon key={i} name="star" />);
    }
  }

  return (
    <SpaceBetween direction="horizontal" size="xxs">
      {icons}
    </SpaceBetween>
  );
}
